import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Link,
	Text,
} from "@chakra-ui/react";
import React from "react";
import { FaLinkedin } from "react-icons/fa";

const FundInFocusMersis: React.FC = () => (
	<>
		{/* members */}
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "450px", sm: "300px" }}
			minH={{ xs: "450px", sm: "300px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir="column"
				px={{ xs: "20px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Heading
					as="h1"
					mb="20px"
					variant="reportCardTitle"
					fontSize={{ xs: "26px", sm: "28px", md: "32px", lg: "38px" }}
					color="white"
					lineHeight={{ xs: "34px", md: "39px", lg: "42px" }}
				>
					Fund In Focus: Merisis Venture Partners on Building a Strong Exit
					Strategy in Growth-Stage Investments
				</Heading>
				<Text
					fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
					fontWeight="600"
					color="white"
					lineHeight="21px"
				>
					Vijay Iyer, Partner,
					<Link
						href="https://www.merisisadvisors.com/merisis-opportunities-fund"
						target="_blank"
						rel="noreferrer"
					>
						Merisis Venture Partners Fund
					</Link>
				</Text>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			<Box as="main" w="100%" pb="40px">
				<Text variant="blogAnswer">
					Welcome to our ‘Fund in Focus’ series where we profile our member VC
					funds, underscore their investment philosophy, and highlight some of
					their interesting work. Today we speak to Vijay Iyer, Partner at
					Merisis Venture Partners Fund who highlights Merisis focus on
					co-investing with top venture capital firms at growth stages, enabling
					risk-mitigated returns for its LPs. The manager also elaborates on
					sector preferences, successful co-investments, and the fund’s
					strategic advantage in India’s evolving growth-stage investment
					landscape. Additionally, the importance of Merisis extensive network
					in facilitating timely exits is underscored, showcasing the
					fund&apos;s comprehensive approach to value creation.
				</Text>
			</Box>

			<Img
				src="https://static.levocdn.com/WGLBUT82/VijayIyer-1d79L5ql3PHW.png"
				alt="Vijay Iyer"
				boxSize="300px"
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "70px" }}
				mb="20px"
				objectFit="contain"
			/>
			<Box>
				<Flex flexDir={{ xs: "column", lg: "row" }} rowGap="16px">
					<Heading
						textAlign={{ xs: "center", md: "left" }}
						fontWeight="800"
						color="blue.400"
					>
						Spokesperson: Vijay Iyer, Partner,
						<Link
							href="https://www.merisisadvisors.com/merisis-opportunities-fund"
							target="_blank"
							rel="noreferrer"
						>
							Merisis Venture Partners Fund
						</Link>
					</Heading>
					<Flex
						columnGap={{ xs: "4px", md: "16px" }}
						justifyContent={{ xs: "center", md: "flex-start" }}
						transform={{ xs: "translateX(12px)", md: "none" }}
					>
						<Box alignSelf="start" mt="5px">
							<Link
								href="https://www.linkedin.com/in/vijayiyer1/"
								target="_blank"
							>
								<IconButton
									aria-label="linkedin"
									icon={
										<FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />
									}
									variant="unstyled"
									cursor="pointer"
								/>
							</Link>
						</Box>
					</Flex>
				</Flex>
				<Box
					ml={{ xs: "auto", md: "345px", lg: "370px" }}
					mr={{ xs: "auto", md: "0px" }}
					width={{ xs: "160px", md: "80px" }}
					h="2px"
					bgColor="primary.500"
					borderRadius="5px"
					mt={{ xs: "16px", md: "10px" }}
					mb="15px"
				/>
				<Box>
					<Heading variant="blogQuestion" pb="20px" pt="16px" pl="-20px">
						1. Can you elaborate on the fund&apos;s investment philosophy and
						how it aims to generate superior risk-mitigated returns for its LPs?
					</Heading>
					<Text variant="blogAnswer" pb="20px">
						The investment philosophy of the Merisis Opportunities Fund focuses
						on co-investing with prominent venture capital firms at a stage
						where the company has achieved product-market fit and is in a
						growth-oriented funding round. This approach inherently mitigates
						risk for our investors due to both the stage of investment/similar
						entry point and the credibility of the Venture Capital firms on the
						cap table. Additionally, we strategically pursue opportunistic
						investments by taking small allocations in bridge rounds when
						company valuations are particularly attractive. Furthermore, our
						deal-by-deal drawdown strategy enhances the internal rate of return
						(IRR), as capital is deployed in investment opportunities at varying
						intervals.
					</Text>
				</Box>
				{/* Question 2 */}
				<Box pt="20px">
					<Heading variant="blogQuestion" pb="20px" pt="30px">
						2. Could you explain the rationale behind co-investing at Series A/B
						stages alongside leading VCs? What benefits does this strategy offer
						to both Merisis and the portfolio companies?
					</Heading>
					<Box>
						<Text variant="blogAnswer" pb="16px">
							Merisis maintains robust relationships with venture capital funds,
							and our co-investment opportunities are influenced by the quality
							of Venture Capital Funds participating in each funding round. We
							prioritize co-investing with funds in whom we have high
							confidence, based on their proven track record and strong domain
							expertise. These funds are also evaluated for their effective
							support of portfolio companies in subsequent funding rounds. This
							approach provides us with validation and confidence in our
							investment decisions. Once a company becomes part of our
							portfolio, we leverage our sectoral expertise and market
							intelligence to offer insights into the funding landscape and
							facilitate connections with potential investors for their future
							funding needs.
						</Text>
					</Box>
				</Box>

				{/* Question 3 */}

				<Box py="16px">
					<Heading variant="blogQuestion" pt="28px">
						3. Can you share an example(s) of a successful co-investment?
					</Heading>
					<Box pt="16px">
						<Text variant="blogAnswer" pb="8px">
							To date, we have co-invested in seven companies. Notably, our
							initial investment, BeatO, has successfully secured a Series B
							funding round with prominent venture capital firms, including
							participation from all existing investors. The continued
							commitment from existing investors in this follow-on round
							enhances the confidence of new investors as well as LPs, thereby
							strengthening their confidence & willingness to invest in these
							portfolio companies.
						</Text>
					</Box>
				</Box>

				{/* Question 4 */}
				<Flex py="16px">
					<Box>
						<Heading variant="blogQuestion" pt="16px">
							4. While the fund is sector agnostic, you have shown a preference
							for Enterprise, FinTech, D2C, and HealthTech. What drives this
							focus, and how do these sectors align with your investment goals?
						</Heading>
						<Box>
							<Text variant="blogAnswer" py="16px">
								Our investment philosophy is grounded in a deep understanding of
								our target sectors. We possess extensive domain expertise via
								our Investment Banking practice across sectors like Enterprise,
								Transportation, Healthcare, Fintech, and Consumer/Tech. Our
								investment thesis is closely aligned with this expertise,
								focusing on new-age digital companies within these five sectors.
								These companies leverage technology to tap into large,
								high-growth markets, which in turn helps us to unlock the target
								IRR to meet our investment goals.
							</Text>
						</Box>
					</Box>
				</Flex>
				{/* Question 5 */}
				<Flex py="16px">
					<Box>
						<Heading variant="blogQuestion" pt="16px">
							5. How does Merisis’ extensive network in the “Exit Ecosystem”
							provide a unique edge in executing prompt exits? Can you share any
							recent success stories?
						</Heading>
						<Box>
							<Text variant="blogAnswer" py="16px">
								Merisis investment team meets potential stakeholders viz
								late-stage fund, Secondary market funds, Corporate
								Development/M&A desk of large listed and unlisted companies in
								the sector. During the process they understand the road map and
								business plans of the stake prospective buyers. This information
								will be very useful whenever the fund decides to exit any
								investment. Our first investment is little over 2 years old and
								we are still invested in all our portfolio companies.
							</Text>
						</Box>
					</Box>
				</Flex>
				{/* Question 6 */}
				<Flex py="16px">
					<Box>
						<Heading variant="blogQuestion" pt="16px">
							6. How do you see the growth-stage investment landscape evolving
							in India, and what role do you envision for Merisis Advisors in
							this transformation?
						</Heading>
						<Box>
							<Text variant="blogAnswer" py="16px">
								The growth stage investment landscape in India is evolving, with
								investors increasingly prioritizing profitability alongside
								innovation. Both founders and investors are now seeking
								collaboration with domain specialists for strategic decisions
								like Investments or M&As. Merisis has adeptly positioned itself
								to meet this shift by developing substantial expertise across
								specialist teams focused on various sectors.
								<br />
								<br />
								Moreover, there is a growing interest from investors in
								traditional promoter-led businesses, which were previously
								considered less attractive. This trend is expected to drive
								significant market consolidation, either through acquisitions by
								major industry players or investments from private equity firms.
								<br />
								<br />
								Merisis, with its proven track record in M&A, is exceptionally
								well-equipped to unlock value in this market. Our strength lies
								in our comprehensive domain knowledge, market intelligence,
								extensive network, and the robust experience of our leadership
								team, which spans multiple industries. As a group, Merisis has
								also expanded into wealth management to cater to founders across
								various stages of their company lifecycle and journey.
							</Text>
						</Box>
					</Box>
				</Flex>
			</Box>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				The content in this section is curated by Team IVCA. For any feedback,
				connect with&nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default FundInFocusMersis;
